import BaseModel from './base.model';

class SamsungOrderInvoiceModel extends BaseModel {
  public id: number;
  public orderNumber: number;
  public lineNumber: number;
  public serialNumber: string = '';
  public coreNumber: string = '';
  public statusCode: string = '';
  public orderStatusCode: string = '';
  public orderStatusDescription: string = '';
  public orderDate: Date;
  public customerCode: string = '';
  public palletRegNumber: number;
  public orderReference: string = '';
  public productCode: string = '';
  public productCodeS1: string = '';
  public productCodeS2: string = '';
  public description: string = '';
  public orderQuantity: number;
  public price: number;
  public invoiceQuantity: number;
  public invoiceDate: Date;
  public invoiceNumber: number;
  public deliveryDate: Date;
  public warehouseCode: string = '';
  public warehouseCity: string = '';
  public motCode: string = '';
  public motDescription: string = '';
  public shipperCode: string = '';
  public trackingNumber: string = '';
  public trackingLink: string = '';
  public shipToName: string = '';
  public shipToCity: string = '';
  public ticket: string = '';
}

export default SamsungOrderInvoiceModel;
